
import React, { useState } from 'react';
import { Button } from '../../../components/base/Button';

export const NewsletterSignup: React.FC = () => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('firstName', firstName);
      formData.append('lastName', lastName);

      const response = await fetch('https://readdy.ai/api/form/d43eqkepguuav66rg060', {
        method: 'POST',
        body: new URLSearchParams(formData as any),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
        setFirstName('');
        setLastName('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 bg-red-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-white mb-4">Stay Connected</h2>
        <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
          Subscribe to our newsletter to receive updates about events, programs, and Persian cultural activities
        </p>

        <form 
          id="newsletter-signup"
          data-readdy-form
          onSubmit={handleSubmit}
          className="max-w-md mx-auto"
        >
          <div className="space-y-4 mb-6">
            <div className="flex space-x-4">
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
              />
            </div>
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
            />
          </div>

          <Button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-white text-red-600 hover:bg-gray-100 font-semibold py-3"
          >
            {isSubmitting ? 'Subscribing...' : 'Subscribe to Newsletter'}
          </Button>

          {submitStatus === 'success' && (
            <p className="mt-4 text-green-200">
              Thank you for subscribing! You'll receive our latest updates.
            </p>
          )}

          {submitStatus === 'error' && (
            <p className="mt-4 text-red-200">
              Something went wrong. Please try again.
            </p>
          )}
        </form>

        <p className="text-red-200 text-sm mt-6">
          We respect your privacy and will never share your information.
        </p>
      </div>
    </section>
  );
};
